import FeatureSection from "../../components/FeatureSection";

function HomeMaintenanceFeatures() {
  return (
    <div>
      <FeatureSection
        title="Effortlessly increase 5-star reviews"
        description="You can collect customer reviews for your business on platforms like Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fa4cae577004a9105da7a7_Group%201000005193%20(6).png"
      />

      <FeatureSection
        title="Effortlessly increase 5-star reviews"
        description="You can collect customer reviews for your business on platforms like Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fa4d3b1746ed1633cf8db9_Group%201000005198%20(4).png"
        reverse
      />

      <FeatureSection
        title="Reward your team for generating more reviews"
        description="Motivate your team to proactively seek customer reviews by launching a well-structured incentive program. Boost participation by recognizing and rewarding top performers, fostering engagement and strengthening your brand’s reputation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f79bf9e329228ca057b896_Frame%202085664989%20(1).png"
      />

      <FeatureSection
        title="Incentivize reviews through leaderboards"
        description="Use leaderboards to drive engagement by tapping into the power of friendly competition, motivating customers to leave more reviews and increase overall participation"
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f79ca070939ac5b4162cea_Frame%202085664987%20(2).png"
        reverse
      />

      <FeatureSection
        title="Motivate your team to enhance Net Promoter Scores (NPS) and Customer Satisfaction (CSAT)"
        description="Inspire your team with targeted incentives to boost Net Promoter Scores (NPS) and Customer Satisfaction (CSAT), fostering outstanding customer experiences."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f79cfb36f66bc7b705a428_Frame%202085664992.png"
      />

      <FeatureSection
        title="AI Generated Surveys"
        description="You can create AI-generated surveys to streamline data collection and gain valuable insights for your business."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f79d7e50e089a79f23b66e_Frame%203%20(3).png"
        reverse
      />

      <FeatureSection
        title="Coupons"
        description="You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f79e1f05d068cb91e44b30_Frame%202085664993.png"
      />

      <FeatureSection
        title="Campaigns"
        description="You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b1d_Frame%201618869448%20(1).png"
        reverse
      />
    </div>
  );
}

export default HomeMaintenanceFeatures;
